import type { IsoDate } from '../../domain/dates';

/**
 * DE: Heutiges Datum in Berlin, unabhängig von der Zeitzone des Geräts.
 * EN: Today's date in Berlin, whatever the device's time zone.
 */
export function todayInBerlin(now: Date): IsoDate {
  // DE: en-CA formatiert als JJJJ-MM-TT, also direkt als ISO-Datum.
  // EN: en-CA formats as YYYY-MM-DD, i.e. directly as an ISO date.
  const berlinDate = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Berlin',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  return berlinDate.format(now);
}

/**
 * DE: Den Browser bitten, die Daten nicht automatisch zu löschen; ohne Unterstützung `false`.
 * EN: Ask the browser not to clear the data automatically; `false` without support.
 */
export async function requestPersistentStorage(
  manager: { persist?: () => Promise<boolean> } | undefined,
): Promise<boolean> {
  return manager?.persist ? manager.persist() : false;
}
